import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import NyliaButton from "../nyliaButton/NyliaButton.js";
import Card from "react-bootstrap/Card";
import image1 from "../../assets/calendar/ballet4-2000.JPG";
import image2 from "../../assets/calendar/ballet2-2000.JPG";
import image3 from "../../assets/performances/SleepingBeauty2026/2026SleepingBeautyAuditions-1280.png";
import image4 from "../../assets/calendar/swanLake1-2000.JPG";
import image5 from "../../assets/calendar/swanLake2-2000.JPG";
import image6 from "../../assets/calendar/tsb1-2000.png";
import image7 from "../../assets/calendar/nbcPhotoshoot26-2000.png";
import image8 from "../../assets/calendar/momAndMeWeek2026.png";
import image9 from "../../assets/calendar/dadAndMeWeek2026.png";
import image10 from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweets2027Poster-2000.png";
import image11 from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweets2027Poster-2000.png";
import image12 from "../../assets/calendar/ BringaFriendWeek2026.png";
import image13 from "../../assets/calendar/CoralineMovieNight2026.png";
import { categoryIDs } from "./CalendarConstants";

import "./EventPopup.css";

// Array. Order is important!
const imagesList = [
  {
    id: 1,
    src: image1,
    alt: "Nylia Ballet Academy's Ballet II classical ballet technique class",
  },
  {
    id: 2,
    src: image2,
    alt: "Nylia Ballet Academy's Ballet IV classical ballet technique class",
  },
  {
    id: 3,
    src: image3,
    alt: "Nylia Ballet Company presents The Sleeping Beauty",
  },
  { id: 4, src: image4, alt: "Nylia Ballet Company presents Swan Lake" },
  { id: 5, src: image5, alt: "Nylia Ballet Company presents Swan Lake" },
  {
    id: 6,
    src: image6,
    alt: "Nylia Ballet Company presents The Sleeping Beauty",
  },
  {
    id: 7,
    src: image7,
    alt: "Nylia Ballet Company and Nylia Ballet Youth Company",
  },
  { id: 8, src: image8, alt: "Nylia Ballet Academy Mom and Me Week" },
  { id: 9, src: image9, alt: "Nylia Ballet Academy Dad and Me Week" },
  {
    id: 10,
    src: image10,
    alt:
      "Nylia Ballet Academy Auditions for Land of the Sweets The Nutcracker's Beginning",
  },
  {
    id: 11,
    src: image11,
    alt: "Nylia Ballet Academy's Land of the Sweets The Nutcracker's Beginning",
  },
  {
    id: 12,
    src: image12,
    alt: "Nylia Ballet Academy Dance El Paso Ballet - Friend Week",
  },
  {
    id: 13,
    src: image13,
    alt: "Nylia Ballet Academy Dance El Paso Ballet - Movie Night",
  },
];

// Joins multiple dates into the card for the label.
function genEventCardDate({ startDate, endDate }) {
  var startMonthDay = "";
  var endMonthDay = "";
  var startYear = startDate.slice(-4);
  var endYear = endDate ? endDate.slice(-4) : "";

  // Is there an end Date? If not, then just use the start date.
  if (endDate) {
    startMonthDay = startDate.slice(0, -6);
    endMonthDay = " - " + endDate.slice(0, -6);
    // Is the end date in the same year?
    endYear = startYear != endYear ? ` - ${endYear}` : "";
  } else {
    startMonthDay = startDate.slice(0, -6);
  }

  return (
    <div>
      <small className="text">{startMonthDay + endMonthDay}</small>
      <p className="eventCardSubtitle">{startYear + endYear}</p>
    </div>
  );
}

// Item contains the event card details. From CalendarConstants.js
function EventPopup({
  eventName,
  category,
  startDate,
  endDate,
  eventTime,
  location,
  imageID,
  links,
  description,
  details,
}) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div id="modalClickButton">
        <Card onClick={handleShow}>
          <Card.Img
            variant="bottom"
            src={imagesList[imageID - 1].src}
          ></Card.Img>
          <Card.ImgOverlay>
            <Card.Header>
              {genEventCardDate({ startDate, endDate })}
            </Card.Header>
          </Card.ImgOverlay>
          <Card.Body>
            <Card.Subtitle></Card.Subtitle>
            <Card.Title id="eventCardTitle">{eventName}</Card.Title>
            <Card.Text>
              {description}
              <br></br>
              <br></br>
              <small className="text">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-clock"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                </svg>
                {"  "}
                {eventTime}
              </small>
            </Card.Text>
          </Card.Body>
          <Card.Footer>{categoryIDs[category - 1].category}</Card.Footer>
        </Card>
      </div>

      <div className="">
        <Modal id="eventPopup" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{eventName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h2>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-calendar-heart"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM1 14V4h14v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1m7-6.507c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132"
                        />
                      </svg>
                      {"  "}
                      {startDate}
                      {endDate && ` - ${endDate}`}
                      <br></br>
                      <br></br>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-clock"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                      </svg>
                      {"  "}
                      {eventTime}
                      <br></br>
                      <br></br>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-pin-map-fill"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"
                        />
                      </svg>
                      {"  "}
                      {location}
                    </h2>
                  </div>
                </div>
                <div className="eventPopupImg">
                  <Card.Img
                    variant="bottom"
                    src={imagesList[imageID - 1].src}
                  ></Card.Img>
                </div>
                <div className="row">
                  <div className="col-12 text-center">
                    <div className="">
                      <br></br>
                      <p>{details}</p>
                    </div>
                  </div>
                  <div className="col-12 text-center">
                    <div className="">
                      {links &&
                        links.map((linkItem, index) => (
                          <div>
                            <hr></hr>
                            <NyliaButton
                              link={linkItem.link}
                              label={linkItem.label}
                            ></NyliaButton>
                          </div>
                        ))}
                      {links && <hr></hr>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer id="eventPopupFooter">
            {categoryIDs[category - 1].category}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default EventPopup;
